import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { TranslateModule } from 'ng2-translate';

import { PipesModule } from '../pipes/pipes.module';
import { LoginComponent } from './login.component';
import { LoginService } from './services/login.service';


const routes: Routes = [
    { path: 'login', component: LoginComponent }
];
@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        PipesModule,
        ButtonsModule,
        InputsModule
    ],
    providers: [
        LoginService
    ],
    declarations: [LoginComponent],
    entryComponents: [LoginComponent]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/modules/login/login.module.ts